module.exports = __webpack_public_path__ + "img/4.b0e9cb13.webp";